<style>
@import '../../assets/css/network.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
           <div class="container-fluid">
               <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <form @submit.prevent="initialize" :submit="initialize">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <el-input v-model="ajaxSearch.login" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                            <b-button variant="primary" class="ml-3" v-model="ajaxSearch.uplevel" v-if="ajaxTable[0].upline" @click="uplevel()">{{$t('admin.table_uplevel')}}</b-button>
                        </b-form-group>
                    </form>
                </b-card>
                <b-card :header="$t($route.name)" header-tag="header">
                    <el-tree :data="ajaxTable" :props="defaultProps" @node-click="handleNodeClick" @node-expand="handleNodeExpand" :expand-on-click-node="false">
                        <span slot-scope="{ node, data }">{{ node.label }}</span>
                    </el-tree>
                </b-card>
                <b-modal id="sponsorPersonal" :title="$t('admin.table_personal_detail')" hide-footer>
                    <b-form-group label-cols="5" label-cols-lg="5">
                        <template slot="label">{{$t('admin.table_personal_sales')}}</template>
                        <label class="from-label">{{ajaxPersonal.personal_sales}}</label>
                    </b-form-group>
                    <b-form-group label-cols="5" label-cols-lg="5">
                        <template slot="label">{{$t('admin.table_group_sales')}}</template>
                        <label class="from-label">{{ajaxPersonal.group_sales}}</label>
                    </b-form-group>
                    <b-form-group label-cols="5" label-cols-lg="5">
                        <template slot="label">{{$t('admin.table_rank')}}</template>
                        <label class="from-label">{{ajaxPersonal.user_rank}}</label>
                    </b-form-group>
                    <b-form-group label-cols="5" label-cols-lg="5">
                        <template slot="label">{{$t('admin.table_badge')}}</template>
                        <label class="from-label">{{ajaxPersonal.user_badge}}</label>
                    </b-form-group>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {sponsorTree,getDownlineInfo,getUserInfo} from '@/system/model/network'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{
            username:'system',
            ajaxLoad:false,
            ajaxTable:[],
            ajaxSearch:{login:'gcamaster',uplevel:''},
            ajaxPersonal:[],
            ajaxRow:'',
            defaultProps: {
                children: 'valid_downline',
                label: 'label',
            }
        }
    },methods:{
        initialize(){
            var self = this;
            var result = sponsorTree(this.ajaxSearch.login,this.ajaxSearch.uplevel);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.thisUserDetail;
                    self.ajaxSearch.login = value.data.thisUserDetail[0].label;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },uplevel(){
            this.ajaxSearch.uplevel = 1;
            this.initialize();
            this.ajaxSearch.uplevel = "";
        },handleNodeClick(data){
            this.tooltipShow = false;
            var self = this;
            var result = getUserInfo(data.label);
            this.preloader(true);
            result.then(function(value){
                if(value.valid){
                    self.preloader(false);
                    self.ajaxPersonal = value.data;
                    self.$bvModal.show('sponsorPersonal');
                }
            });
        },handleNodeExpand(data){
            this.tooltipShow = false;
            var self = this;
            var result = getDownlineInfo(data.label);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    data.valid_downline = value.data;
                }
            });
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
